// Utilities
import isEmpty from '../../utility/isEmpty'

// Vuex
import { defaultObj } from './state'

export default {
  setVueInstance (state, vueInstance) {
    if (!isEmpty(vueInstance)) {
      state.vueInstance = vueInstance
    }
  },

  authenticated (state, userData) {
    state.authenticated = true
    state.user = userData.user
    state.username = userData.username

    state.email = userData.email
    state.emailVerified = userData.emailVerified
    state.phone = userData.phone
    state.phoneVerified = userData.phoneVerified

    state.verified = true
    state.isGuestPayOnlyUser = userData.isGuestPayOnlyUser
  },

  unverified (state, userData) {
    state.authenticated = userData.authenticated ?? true
    state.user = userData.user
    state.username = userData.username
    state.verified = false
    state.deviceIsTrusted = false
    state.isReferralOnly = userData.isReferralOnly
  },

  signout (state) {
    state.authenticated = false
    state.user = null
    state.email = ''
    state.phone = ''
    state.verified = false
    state.deviceIsTrusted = false
  },

  setSignOutInProgress (state, value) {
    state.signOutInProgress = value
  },

  setUserData (state, userData) {
    if (userData.hasOwnProperty('username')) {
      state.username = userData.username
    }
    state.password = userData.password
  },

  updateSessionTimeout (state, timeoutData) {
    state.sessionTimeoutStart = timeoutData.timeoutStart
    state.sessionTimeoutIsActive = timeoutData.timeoutIsActive
    state.sessionTimeoutSkip = timeoutData.skipTimeout
  },

  setSessionTimeoutOver (state, data) {
    state.sessionTimeoutIsOver = data.isOver
  },

  updateServiceStatus (state, statusData = {}) {
    if (!isEmpty(statusData.available)) {
      state.serviceAvailable = statusData.available
    }
  },

  updatePreviousPage (state, previousInfo) {
    if (previousInfo) {
      state.previousPage = previousInfo.previousPage
      state.previousProps = previousInfo.previousProps
    }
  },

  updateConfigSettings (state, data) {
    if (data.broadcastMessage !== undefined) {
      state.broadcastMessage = data.broadcastMessage
    }

    if (data.manageNotifications !== undefined) {
      state.allowManageNotifications = data.manageNotifications
    }

    if (data.allowNoSsnRefi !== undefined) {
      state.allowNoSsnRefi = data.allowNoSsnRefi
    }

    if (data.refiPaymentTimeOut) {
      state.refiPaymentTimeoutLimit = data.refiPaymentTimeOut
    }

    if (data.paymentTimeOut) {
      state.paymentTimeoutLimit = data.paymentTimeOut
    }

    if (data.sessionTimeOut) {
      state.sessionTimeoutLimit = data.sessionTimeOut
    }

    if (data.disbursementMaxPollingAttempts !== undefined) {
      state.disbursementMaxPollingAttempts = data.disbursementMaxPollingAttempts
    }

    if (data.loanDocumentUploadSettings) {
      if (data.loanDocumentUploadSettings.LocalFileMimeFilter) {
        state.loanDocUploadFileTypes = data.loanDocumentUploadSettings.LocalFileMimeFilter
      }

      if (data.loanDocumentUploadSettings.InputAcceptFilter) {
        state.loanDocUploadInputTypes = data.loanDocumentUploadSettings.InputAcceptFilter
      }

      if (data.loanDocumentUploadSettings.MaxUploadSizeInMegabytes) {
        state.loanDocUploadMaxSize = data.loanDocumentUploadSettings.MaxUploadSizeInMegabytes
      }

      if (data.loanDocumentUploadSettings.MaxUploadsPerDay) {
        state.loanDocUploadFileLimit = data.loanDocumentUploadSettings.MaxUploadsPerDay
      }

      if (data.loanDocumentUploadSettings.AllowedFileExtensions) {
        state.loanDocAllowedFileTypes = data.loanDocumentUploadSettings.AllowedFileExtensions
      }
    }

    if (data.pastDuePhoneDayLimit !== undefined) {
      state.pastDuePhoneDayLimit = data.pastDuePhoneDayLimit
    }

    if (data.menuItemVisibility !== undefined) {
      state.menuItemVisibility = data.menuItemVisibility
    }

    if (data.servicesConfig !== undefined) {
      state.servicesConfig = data.servicesConfig
    }

    if (data.deviceDetection !== undefined) {
      state.deviceDetection = data.deviceDetection
    }

    if (data.canUploadTlxeLoanDocuments !== undefined) {
      state.canUploadTlxeLoanDocuments = data.canUploadTlxeLoanDocuments
    }

    if (data.settlementPaymentRetryLimit !== undefined) {
      state.settlementPaymentRetryLimit = data.settlementPaymentRetryLimit
    }

    if (data.canUseDisbursementPolling !== undefined) {
      state.canUseDisbursementPolling = data.canUseDisbursementPolling
    }

    if (data.displayReferralBalanceHistory !== undefined) {
      state.displayReferralBalanceHistory = data.displayReferralBalanceHistory
    }

    if (data.displayNonCustomerReferral !== undefined) {
      state.displayNonCustomerReferral = data.displayNonCustomerReferral
    }

    if (data.displayRetailReferral !== undefined) {
      state.displayRetailReferral = data.displayRetailReferral
    }

    if (data.outForRepoConfig !== undefined) {
      state.outForRepoConfig = data.outForRepoConfig
    }

    if (data.debtSoldConfig !== undefined) {
      state.debtSoldConfig = data.debtSoldConfig
    }

    if (data.docuSignRedirect !== undefined) {
      state.docuSignRedirect = data.docuSignRedirect
    }

    if (data.checkAddonGps !== undefined) {
      state.checkAddonGps = data.checkAddonGps
    }

    if (data.checkPaymentGps !== undefined) {
      state.checkPaymentGps = data.checkPaymentGps
    }

    if (data.checkRefiGps !== undefined) {
      state.checkRefiGps = data.checkRefiGps
    }

    if (data.forceAddonGps !== undefined) {
      state.forceAddonGps = data.forceAddonGps
    }

    if (data.forcePaymentGps !== undefined) {
      state.forcePaymentGps = data.forcePaymentGps
    }

    if (data.forceRefiGps !== undefined) {
      state.forceRefiGps = data.forceRefiGps
    }

    if (data.canSendVoiceMessages !== undefined) {
      state.canSendVoiceMessages = data.canSendVoiceMessages
    }

    if (data.shareTitlemaxEnabled !== undefined) {
      state.shareTitlemaxEnabled = data.shareTitlemaxEnabled
    }

    if (data.restrictManualRetryConfig !== undefined) {
      if (data.restrictManualRetryConfig.enabled !== undefined) {
        state.restrictManualRetry = data.restrictManualRetryConfig.enabled
      }

      if (data.restrictManualRetryConfig.intervalInMinutes !== undefined) {
        state.restrictedRetryTimeInMins = data.restrictManualRetryConfig.intervalInMinutes
      }
    }

    if (data.wrongPasswordRedirectCount !== undefined) {
      state.wrongPasswordRedirectCount = data.wrongPasswordRedirectCount
    }

    if (data.bridgePaySettings !== undefined) {
      state.bridgePaySettings = data.bridgePaySettings
    }

    if (data.loanOriginateTimeout) {
      state.loanOriginateTimeout = Number.parseInt(data.loanOriginateTimeout)
    }

    if (data.postDrawTimeout) {
      state.postDrawTimeout = Number.parseInt(data.postDrawTimeout)
    }

    if (data.canEditPhone) {
      state.canEditPhone = data.canEditPhone
    }

    if (data.canEditEmail) {
      state.canEditEmail = data.canEditEmail
    }

    if (data.autoPayStandardPayment) {
      state.autoPayStandardPayment = data.autoPayStandardPayment
    }

    if (data.autoPayRefi) {
      state.autoPayRefi = data.autoPayRefi
    }

    if (data.autoPayReapply) {
      state.autoPayReapply = data.autoPayReapply
    }

    if (data.cancelRefiTimeout) {
      state.cancelRefiTimeout = Number.parseInt(data.cancelRefiTimeout)
    }

    if (data.canUnitasCardCreate) {
      state.canUnitasCardCreate = data.canUnitasCardCreate
    }

    if (data.canRepayCardCreate) {
      state.canRepayCardCreate = data.canRepayCardCreate
    }

    if (!isEmpty(data.awaitingSignature)) {
      state.awaitingSignature = data.awaitingSignature
    }

    if (!isEmpty(data.expressFlowEnabled)) {
      state.expressFlowEnabled = data.expressFlowEnabled
    }

    if (!isEmpty(data.displayDocumentUploadMenuItem)) {
      state.displayDocumentUploadMenuItem = data.displayDocumentUploadMenuItem
    }

    if (!isEmpty(data.canMigrateProfileToEmail)) {
      state.canMigrateProfileToEmail = data.canMigrateProfileToEmail
    }

    if (!isEmpty(data.canSkipMigrateProfileToEmail)) {
      state.canSkipMigrateProfileToEmail = data.canSkipMigrateProfileToEmail
    }

    if (!isEmpty(data.updateUsernameInfo)) {
      state.updateUsernameInfo = data.updateUsernameInfo
    }

    if (!isEmpty(data.repayConfig)) {
      state.repayConfig = data.repayConfig
    }

    state.savedConfigSettings = true
  },

  setInternalRedirect (state, route) {
    state.internalRedirect = route
  },

  clearInternalRedirect (state) {
    state.internalRedirect = defaultObj.internalRedirect
  },

  setForceShowProductSwitchModal (state, data) {
    state.forceShowProductSwitchModal = data
  },

  setForceShowRenewalStatement (state, data) {
    state.forceShowRenewalStatement = data
  },

  setFromLegacyNcr (state, data) {
    state.fromLegacyNcr = data
  },

  setGpsPosition (state, data) {
    if (!isEmpty(data.latitude) && !isEmpty(data.longitude)) {
      state.gpsPosition.latitude = data.latitude
      state.gpsPosition.longitude = data.longitude
    }
  },

  setPasswordPolicy (state, data) {
    if (data.minimumLength !== undefined) {
      state.passwordPolicy.minimumLength = data.minimumLength
    }

    if (data.requireLowercase !== undefined) {
      state.passwordPolicy.requireLowercase = data.requireLowercase
    }

    if (data.requireNoSpaces !== undefined) {
      state.passwordPolicy.requireNoSpaces = data.requireNoSpaces
    }

    if (data.requireNumbers !== undefined) {
      state.passwordPolicy.requireNumbers = data.requireNumbers
    }

    if (data.requireSymbols !== undefined) {
      state.passwordPolicy.requireSymbols = data.requireSymbols
    }

    if (data.requireUppercase !== undefined) {
      state.passwordPolicy.requireUppercase = data.requireUppercase
    }
  },

  setAccountCreated (state, data) {
    state.accountCreatedSession = data.accountCreated
  },

  setDeviceIsTrusted (state, value) {
    state.deviceIsTrusted = value
  },

  reset (state) {
    state = Object.assign(state, defaultObj)

    if (this.cache.has('session/getServiceStatus') === true) {
      this.cache.delete('session/getServiceStatus')
    }
  },

  setVerified (state, data) {
    state.verified = data.verified

    if (data.username !== undefined) {
      state.username = data.username
    }
  }
}
